<template>
  <div class="thermique">
    <div class="thermique__topfold">
      <div v-html="imageHtml"></div>
      <div>
        <h1>{{ product.name }} &#x25CF; <span v-html="product.price_html"></span></h1>
        <p v-html="product.short_description"></p>
        <!--        <iframe id="js-product-video-iframe" class="float-center" width="853" height="480" data-skip-lazy-->
        <!--          :src="`//www.youtube.com/embed/uNH-hEQJndI?enablejsapi=1&origin=https://www.go2roues.com`"-->
        <!--          allowfullscreen></iframe>-->
      </div>
    </div>
    <div class="thermique__belowfold">
      <ul class="thermique__tabs">
        <li :class="{active: tabDisplay === 'desc'}" @click="tabDisplay = 'desc'">Description</li>
        <li :class="{active: tabDisplay === 'tech'}" @click="tabDisplay = 'tech'">Spécifications Techniques</li>
      </ul>
      <div class="thermique__tabcontent">
        <div v-show="tabDisplay === 'desc'" v-html="product.description"></div>
        <div v-show="tabDisplay === 'tech'">
          <div v-for="attribute in product.attributes">
            <template v-if="attribute.visible">
              <b>{{ attribute.name }}</b> : <span v-for="option in attribute.options">{{ option }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <h2>Que vaut-il face à l'électrique
      <Flash :width="18" :height="18"/>
    </h2>
    <div class="thermique__dualpane" v-if="null !== thermiqueData">
      <div class="dualpane__inner" v-html="thermiqueData.queVautIl"></div>
      <div class="dualpane__inner">
        <EV v-for="(ev,i) in product.evs" :description="thermiqueData.evs[i].description" :ev="ev"/>
        <div class="dualpane__button">
          <button type="button" @click="compare">
            <Comparateur :size="14" fill="white"/>
            COMPARER AU {{ product.name.toUpperCase() }}
          </button>
        </div>
      </div>
    </div>
    <!--    <h2>Autres tests</h2>-->
    <!--    <button type="button" @click="load">RELOAD</button>-->
  </div>
</template>

<script>
import EV from "@/front/components/blog/thermique/EV";
import Flash from "@/components/icons/Flash";
import Comparateur from "@/components/icons/Comparateur";

export default {
  name: "TestThermique",
  components: {Comparateur, Flash, EV},
  data() {
    return {
      productId: 0,
      imageHtml: {},
      product: {},
      loading: false,
      tabDisplay: 'desc',
    }
  },
  computed: {
    thermiqueData() {
      if (this.product.hasOwnProperty('meta_data')) {
        const t = this.product.meta_data.find(meta => meta.key === '_g2r_thermique_data')
        if (undefined !== t) {
          return t.value;
        }
      }

      return null
    },
  },
  methods: {
    compare() {
      const comp = JSON.parse(localStorage.getItem('comparateur')) || [];
      if (comp.length > 0) {
        const ok = confirm(`Le comparateur sera vidé pour y ajouter le ${this.entryTitle} et ses équivalents électriques. Veuillez confirmer.`)
        if (ok) {
          let array = [{product: this.productId, variation: 0}]
          const evs = this.thermiqueData.evs
          Object.keys(evs).forEach(key => {
            if (evs[key].id > 0) {
              array.push({product: evs[key].id, variation: 0});
            }
          })
          localStorage.setItem('comparateur', JSON.stringify(array));
          cpVm.$children[0].displayPreview();
        }
      }
    },
    load() {
      this.loading = true
      $api.get(`wc/v3/products/${this.productId}`, {
        auth: {
          username: 'ck_1a4505854ff29868e87378231d7faa1eb2028787',
          password: 'cs_2ff991b48fe64cc576d4c27dbe2bb4f7e4581261',
        }
      }).then(response => response.data)
        .then(data => this.product = data)
        .finally(() => this.loading = false)
    },
  },
  beforeMount() {
    new Promise(resolve => {
      resolve(JSON.parse(document.getElementById('test-thermique-data').innerHTML))
    }).then(data => {
      this.productId = data.productId
      this.imageHtml = data.imageHtml
    })
      .then(() => this.load())
  },
}
</script>

<style scoped lang="scss">
.single-post .entry-content {
  .thermique {
    .thermique__topfold {
      display: grid;
      grid-column-gap: 2%;
      margin-bottom: 3rem;
    }

    .thermique__belowfold {
      margin-bottom: 3rem;

      .thermique__tabs { // ul
        display: flex;
        margin: 0;
        font-family: "Saira Semi Condensed", sans-serif;
        font-size: 1.8rem;
        border-bottom: 3px solid whitesmoke;

        li {
          list-style: none;
          padding: 1rem 2rem;
          background-color: var(--dark-blue);
          color: white;
          cursor: pointer;
          margin-right: 1rem;
          line-height: 1;
          display: flex;
          align-items: center;

          &.active {
            background-color: #fbfbfb;
            color: var(--dark-blue);
          }
        }
      }

      .thermique__tabcontent {
        padding: 2rem;
        background-color: #fbfbfb;
        max-height: 500px;
        overflow: scroll;
      }
    }

    .thermique__dualpane {
      margin-bottom: 3rem;

      div {
        &.dualpane__inner {
          border: 2px outset var(--dark-blue);
          min-height: 300px;
          padding: 2rem;

          @media screen and (max-width: 767px) {
            &:first-child {
              border-bottom: none;
            }
          }

          .dualpane__button {
            display: flex;
            justify-content: flex-end;

            button {
              display: flex;
              align-items: center;

              svg {
                margin-right: 1rem;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .single-post .entry-content {
    .thermique {
      .thermique__topfold {
        grid-template-columns: 1fr 1fr;
      }

      .thermique__dualpane {
        display: grid;
        grid-template-columns: 1fr 1fr;

        div {
          &:first-child {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>
